import UploadCloudIcon from "@redotech/redo-icons/upload-cloud-02.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoCollapseSubsection } from "@redotech/redo-web/arbiter-components/collapse/redo-collapse-section";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { useGorgiasKnowledgeImport } from "../../gorgias-import/use-gorgias-import";

export const GorgiasKnowledgeTab = memo(function GorgiasKnowledgeTab({
  teamId,
}: {
  teamId: string | undefined;
}) {
  const { jsonText, setJsonText, loading, handleImport } =
    useGorgiasKnowledgeImport({ teamId });

  return (
    <Flex dir="column" gap="md">
      <Text fontSize="sm" textColor="secondary">
        Paste the JSON response from the Gorgias Knowledge Base / Help Center
        articles API endpoint. Articles will be imported as AI knowledge entries
        that can be used by the support agent.
      </Text>
      <RedoCollapseSubsection title="Instructions">
        <Flex dir="column" gap="sm" pl="lg">
          <Text fontSize="sm" textColor="secondary">
            To add this import:
          </Text>
          <Text fontSize="sm" textColor="secondary">
            <li>
              • Go to Gorgias and open your developer tools (right click,
              inspect)
            </li>
            <li>• Go to the network tab</li>
            <li>• Search for "articles?"</li>
            <li>• Go to the knowledge base / help center section in Gorgias</li>
            <li>• Copy the response and paste it into this input</li>
          </Text>
        </Flex>
      </RedoCollapseSubsection>
      <RedoTextareaInputField
        disabled={loading}
        label="Gorgias knowledge JSON"
        placeholder="Paste Gorgias knowledge base articles JSON here"
        setValue={setJsonText}
        value={jsonText}
      />
      <div>
        <RedoButton
          disabled={!jsonText.trim() || loading}
          hierarchy="primary"
          IconLeading={UploadCloudIcon}
          onClick={handleImport}
          pending={loading}
          size="md"
          text="Import knowledge"
          theme="normal"
        />
      </div>
    </Flex>
  );
});
